import { useMemo } from "react";

type PositionRandomProps = {
  x: number;
  y: number;
};

/**
 *
 * @param cantPisiciones
 * @description genera posiciones random, dentro de la pantalla, para las figuras existentes
 */
export const usePositionsRandom = (
  cantPisiciones: number
): PositionRandomProps[] => {
  const posiciones: PositionRandomProps[] = [];
  for (let index = 0; index < cantPisiciones; index++) {
    const x = (window.innerHeight - 300) / Math.floor(Math.random() * 11);
    const y = (window.innerWidth - 500) / Math.floor(Math.random() * 11);
    posiciones.push({ x, y });
  }

  return useMemo(
    () => ({
      ...posiciones
    }),
    [cantPisiciones]
  );
};
